import axios from "axios";
import Product from "@/models/Product";
import { useProductStore } from "@/stores/root/products";

export default class ProductService {
  /**
   * Gets all products from remote system.
   * @returns
   */
  static async all(): Promise<Product[]> {
    const productStore = useProductStore();
    //let products = (store.state as any).Root.products;
    let products = (productStore as any).products;
    if (!products[0]) {
      const { data } = await axios.get(
        process.env.VUE_APP_MAGENTO_URL + "/rest/V1/NSSI/products/assurantad"
      );
      //store.commit("Root/SET_PRODUCTS", Object.values(data));
      productStore.SET_PRODUCTS(Object.values(data));
      //products = (store.state as any).Root.products;
      products = (productStore as any).products;
    }
    return products;
  }
}
